import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import clsx from 'clsx';
import { usePaginationStyles } from '../styles/index.js';

const DOT_WIDTH = 16;
const BASE_VISIBLE = 5;
const MAX_VISIBLE = 6;
const CarouselPagination = ({ total, activeIndex, onChange, dotsPlacement, }) => {
    const styles = usePaginationStyles({ dotsPlacement });
    const scrollerRef = useRef(null);
    const getVisibleCount = () => (total > 6 && activeIndex >= 3 ? BASE_VISIBLE + 1 : BASE_VISIBLE);
    const visibleCount = getVisibleCount();
    useEffect(() => {
        const getTranslateX = () => {
            if (total <= visibleCount)
                return 0;
            if (activeIndex <= 2)
                return 0;
            if (activeIndex >= total - 3)
                return (total - visibleCount) * DOT_WIDTH;
            return (activeIndex - 3) * DOT_WIDTH;
        };
        const scroller = scrollerRef.current;
        if (scroller) {
            scroller.style.transform = `translateX(-${getTranslateX()}px)`;
        }
    }, [activeIndex, total, visibleCount]);
    const getVisibleRange = () => {
        if (total < MAX_VISIBLE)
            return [0, total];
        if (total <= visibleCount)
            return [0, total - 1];
        if (activeIndex <= 2)
            return [0, visibleCount - 1];
        if (activeIndex >= total - 3)
            return [total - visibleCount + 1, total - 1];
        const offset = Math.floor(visibleCount / 2);
        return [activeIndex - offset, activeIndex + (visibleCount - offset - 1)];
    };
    const [visibleStart, visibleEnd] = getVisibleRange();
    return (jsx("div", { className: styles.pagination, children: jsx("ul", { className: styles.scroller, ref: scrollerRef, "data-testid": "pagination", children: Array.from({ length: total }, (_, i) => {
                const isActive = i === activeIndex;
                const isVisible = i >= visibleStart && i <= visibleEnd;
                const isMid = i > visibleStart && i < visibleEnd;
                const isSmallStart = i === visibleStart && activeIndex > 3 && visibleStart > 0 && !isVisible;
                const isSmallEnd = i === visibleEnd && activeIndex < total - 3 && visibleEnd < total - 1;
                const isNormal = (i === visibleStart && activeIndex < 4) || (i === visibleEnd && activeIndex > total - 3);
                return (jsx("li", { className: clsx(styles.paginationItem, isVisible && styles.visible, isMid && styles.midVisible, isNormal && styles.normal, (isSmallStart || isSmallEnd) && styles.edgeDot, isActive && styles.active), onClick: () => onChange(i + 1) }, i));
            }) }) }));
};

export { CarouselPagination };
